export default __webpack_public_path__ + "static/media/trajectory.9caf0d0b.png";